import jQuery from "jquery";
import {Popover} from 'bootstrap';

/**
 * Inicjuje popover
 * @param {HTMLElement|jQuery|string} selector
 * @param {object} config
 */
export const initPopover = (selector, config = {}) => {
    jQuery(selector).each((i, el) => {
        new Popover(el, config);
    });
}

/**
 * Pokazuje popover
 * @param {HTMLElement|jQuery|string} selector
 * @param {object} config
 */
export const showPopover = (selector, config = {}) => {
    jQuery(selector).each((i, el) => {
        Popover.getOrCreateInstance(el, config).show()
    });
}

/**
 * Chowa popover
 * @param {HTMLElement|jQuery|string} selector
 */
export const hidePopover = selector => {
    jQuery(selector).each((i, el) => {
        const popover = Popover.getInstance(el);
        if (popover) {
            popover.hide();
        }
    });
}

/**
 * Chowa popover
 * @param {HTMLElement|jQuery|string} selector
 */
export const disposePopover = selector => {
    jQuery(selector).each((i, el) => {
        const popover = Popover.getInstance(el);
        if (popover) {
            popover.dispose();
        }
    });
}

/**
 * @param {HTMLElement|jQuery|string} selector
 * @returns {Popover}
 */
export const getPopover = selector => {
    const el = jQuery(selector)[0];
    if (el) {
        return Popover.getOrCreateInstance(el);
    }
    return null;
}

/**
 * @param {HTMLElement|jQuery|string} selector
 * @param {string} content
 * @returns {Popover}
 */
export const setPopoverContent = (selector, content) => {
    const el = jQuery(selector)[0];
    if (el) {
        const popover = Popover.getInstance(el);
        if (popover) {
            popover._config.content = String(content);
            if (popover.tip) {
                const popoverBody = popover.tip.querySelector('.popover-body');
                if (popoverBody) {
                    popover.setElementContent(popoverBody, String(content));
                }
            }
        }
        return popover;
    }
}

document.addEventListener("DOMContentLoaded", function () {
    // Dla kompatybilności z Bootstrap 3/4
    initPopover('[data-toggle="popover"]', {
        container: 'body',
        placement: 'top',
        trigger: 'hover',
        html: true,
        content: (el) => {
            return String((el.dataset || {}).content || '');
        },
    });

    // Bootstrap 5
    initPopover('[data-bs-toggle="popover"]', {
        container: 'body',
        placement: 'top',
        trigger: 'hover',
        html: true,
    });
});
